import React, { useEffect, useRef, useState } from 'react';
import i18n from 'i18n-js';
import SerialRecord from '../components/scanpack/serial_record';

const AUTO_CLOSE_MS = 4000;

export const getSerialNoteText = (item) => {
  if (!item) return null;
  let target = item;
  if (
    item.product_type === 'individual' &&
    item.child_items &&
    item.child_items.length > 0
  ) {
    target = item.child_items[0];
  }
  const recordSerial = target?.record_serial === true;
  const recordSecondSerial = target?.second_record_serial === true;
  if (!recordSerial && !recordSecondSerial) return null;
  return recordSerial && recordSecondSerial
    ? i18n.t('nextItems.serialRecordingNoteTwo')
    : i18n.t('nextItems.serialRecordingNote');
};

const SerialRecordingNoteModal = ({ item }) => {
  const [visible, setVisible] = useState(false);
  const [noteText, setNoteText] = useState('');
  const lastProductId = useRef(null);
  const timerRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const close = () => {
    clearTimer();
    setVisible(false);
  };

  useEffect(() => {
    const productId = item?.product_id;
    if (!productId || productId === lastProductId.current) return;
    lastProductId.current = productId;
    const text = getSerialNoteText(item);
    if (!text) return;
    setNoteText(text);
    setVisible(true);
    clearTimer();
    timerRef.current = setTimeout(() => setVisible(false), AUTO_CLOSE_MS);
  }, [item?.product_id]);

  useEffect(() => () => clearTimer(), []);

  if (!visible) return null;

  return (
    <SerialRecord
      noteMode={true}
      serialRecordText={noteText}
      closeSerialRecord={close}
    />
  );
};

export default SerialRecordingNoteModal;
